// @flow
import React from 'react';
import { Link } from 'react-router-dom';

import { formatDateWithAbbvStr, formatHours } from 'utils/dateUtils';
import { getGGMapsLink } from 'utils/urlUtils';
import { ffrName } from 'utils/ffrNameUtils';

import type { ResultCalendarType } from 'types/Result';

type Props = {
  result: ResultCalendarType,
  teamSlug: string,
};

const CardNextMatch = ({ result, teamSlug }: Props) => {
  const {
    id,
    competition: {
      nom: competitionNom,
      famille: competitionFamille,
      age,
      sexe
    },
    journee: {
      nom: journeeNom
    },
    localStructure: {
      nom: localStructureNom,
      embleme: localStructureEmbleme,
    },
    visiteurStructure: {
      nom: visiteurStructureNom,
      embleme: visiteurStructureEmbleme,
    },
    dateEffective,
    terrain: {
      nom: terrainNom,
      coordinates,
      localite,
      address,
    },
    etat,
  } = result;

  return (
    <div className="box card card--score score-team box--white mt-2 upcoming">
      <div className="card__header">
        <div>
          <span className="ft-h6 ft-up">{competitionFamille+ ' ' +age+sexe}</span>
          <span className="ft-h6">{competitionNom} — {journeeNom}</span>
        </div>
        <span className="ft-h6 ft-up label">{etat === 'En direct' ? 'En cours' : 'À venir'}</span>
      </div>
      <div className="card__body">
        <Link to={`/equipes/${teamSlug}/match/${id}`} className="match">
          <div className="match__club">
            <p className="ft-h3 ft-400">
              <span>{ffrName(localStructureNom)}</span>
              <img
                src={localStructureEmbleme}
                alt={`Logo ${ffrName(localStructureNom)}`}
                width="24"
                height="24"
              />
            </p>
          </div>
          <div className="match__info">
            <p className="match__time ft-700 ft-up">
              {formatDateWithAbbvStr(dateEffective || new Date())}
              <br/>
              {formatHours(dateEffective || new Date())}
            </p>
          </div>
          <div className="match__club">
            <p className="ft-h3 ft-400">
              <img
                src={visiteurStructureEmbleme}
                alt={`Logo ${ffrName(visiteurStructureNom)}`}
                width="24"
                height="24"
              />
              <span>{ffrName(visiteurStructureNom)}</span>
            </p>
          </div>
        </Link>
        <a
          href={getGGMapsLink(coordinates, `${terrainNom} ${address}`)}
          target="_blank"
          rel="noreferrer noopener nofollow"
          title="Voir l'adresse sur Google Map (nouvel onglet)"
          className="event__info mt-3 ft-700"
        >
          <i className="icon icon-place is-inline"/>
          {`${terrainNom}, ${localite}`}
        </a>
      </div>
    </div>
  );
};


export default CardNextMatch;
